import { render, staticRenderFns } from "./iconDeleteCart.vue?vue&type=template&id=b106faca"
import script from "./iconDeleteCart.vue?vue&type=script&lang=js"
export * from "./iconDeleteCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports